import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { blueLabelText } from "design-system/colors";
import OverflowTooltip from "design-system/components/OverflowTooltip";
import { EditIcon } from "design-system/icons";
import { formatPhoneNumber } from "globals/utils/phoneNumberFormatter/phoneNumberFormatter";

import NewCustomer from "design-system/images/NewCustomer.svg";
import { useBookingContactIsNewCustomer } from "globals/hooks";
import MoovsTooltip from "components/MoovsTooltip";
import { Request } from "types";
import { deriveBookingContact, deriveIsFarmee } from "globals/utils/farm";

type BookingContactBlockProps = {
  request: Request;
  onBookingContactUpdate: (e: any) => void;
  canEditBookingContact?: boolean;
};

const BookingContactBlock = (props: BookingContactBlockProps) => {
  const { request, onBookingContactUpdate, canEditBookingContact } = props;

  // display booking contact
  const bookingContact = deriveBookingContact(request);

  // only evaluate new customer if is non-farmed or is farmor
  const isFarmee = deriveIsFarmee(request.trips[0].routes[0]);
  const isNewCustomer = useBookingContactIsNewCustomer({
    contactId: isFarmee ? null : request.bookingContact.id,
  });

  return (
    <>
      <Box mb="2px" display="flex" flexDirection="row">
        <Box mr={1} mt={-0.3}>
          <Typography variant="overline">Booking Contact</Typography>
        </Box>

        {isNewCustomer && (
          <MoovsTooltip tooltipText="New customer">
            <img
              src={NewCustomer}
              alt="New Customer Label"
              style={{
                maxHeight: "433px",
              }}
            />
          </MoovsTooltip>
        )}
      </Box>
      <Box mb="1px" display="flex" flexDirection="row">
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", position: "relative", top: "4px" }}
        >
          {bookingContact.name}
        </Typography>
        {canEditBookingContact && (
          <IconButton
            onClick={() => onBookingContactUpdate(true)}
            sx={{
              "&.MuiButtonBase-root": { padding: 0 },
              ml: 1,
            }}
          >
            <EditIcon color={blueLabelText} />
          </IconButton>
        )}
      </Box>
      <Box mb="1px">
        <OverflowTooltip
          variant="body2"
          toolTipText={bookingContact?.email || "-"}
          displayText={bookingContact?.email || "-"}
          arrow={true}
        />
      </Box>
      {bookingContact.phoneNumber && (
        <OverflowTooltip
          variant="body2"
          toolTipText={
            formatPhoneNumber(bookingContact.phoneNumber).formatted || "-"
          }
          displayText={
            formatPhoneNumber(bookingContact.phoneNumber).formatted || "-"
          }
          arrow={true}
        />
      )}
    </>
  );
};

export default BookingContactBlock;
